export default __webpack_public_path__ + "static/media/LouverSwing.c36094b7.svg";